import { useGameRoundTiles } from '@/api/game-round';
import Roulette from '@/components/core/Roulette';
import { Round } from '@/models/round';
import { Tile } from '@/models/tiles';
import { getCardIndex } from '@/utils/roulette/getCardIndex';
import { ErrorCard } from '@starsoft/common/components';
import { useMemo } from 'react';
import FortuneDoubleCard from './Card';
import { FortuneDoubleRouletteProps } from './props';
import { Container } from './styles';

export default function FortuneDoubleRoulette({
  round,
  isRoundClosed = true,
  onPrizeDefined = () => {},
  spinningTime = 3,
  isLoading,
}: FortuneDoubleRouletteProps) {
  const {
    tiles,
    originalTiles,
    isLoading: isLoadingTiles,
    error: errorTiles,
    refetch,
  } = useGameRoundTiles({
    roundId: round?.id?.toString(),
  });

  const prizeIndex = useMemo(
    () => getCardIndex(round as Round, tiles, originalTiles),
    [round, tiles, originalTiles],
  );

  if (errorTiles) {
    return <ErrorCard error={errorTiles} refetch={refetch} />;
  }

  return (
    <Container>
      <Roulette
        prizes={tiles}
        prizeIndex={prizeIndex}
        customCard={(data: Tile) => (
          <FortuneDoubleCard
            data={data}
            isLoading={isLoadingTiles || isLoading}
          />
        )}
        start={isRoundClosed}
        spinningTime={spinningTime}
        onPrizeDefined={onPrizeDefined}
        firstItem={15}
        isTransparent
      />
    </Container>
  );
}
